// extracted by mini-css-extract-plugin
export default {"filter":"ProductFilter_filter__o-x7B","category":"ProductFilter_category__rSYd+","active":"ProductFilter_active__DNDAN","brand":"ProductFilter_brand__d-QHm"};